import React from 'react';
import RecipeCard from './RecipeCard';
import { useFavorites } from '@/hooks/useFavorites';
import { Button } from '@/components/ui/button';
import { RefreshCw, Heart } from 'lucide-react';

interface FavoriteRecipesProps {
    onAddToWeeklyMenu: (recipeId: number, recipeTitle: string) => void;
}

const FavoriteRecipes = ({ onAddToWeeklyMenu }: FavoriteRecipesProps) => {
    const { favorites,favoriteIds, toggleFavorite, loading, error, refetch } = useFavorites();

    if (loading) {
        return (
            <div className="flex justify-center items-center py-12">
                <div className="flex items-center gap-2 text-gray-600">
                    <RefreshCw className="h-4 w-4 animate-spin" />
                    Cargando recetas favoritas...
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="text-center py-12">
                <div className="text-red-600 mb-4">Error: {error}</div>
                <Button onClick={refetch} variant="outline">
                    Reintentar
                </Button>
            </div>
        );
    }

    if (favorites.length === 0) {
        return (
            <div className="text-center py-12">
                <Heart className="h-12 w-12 text-gray-300 mx-auto mb-4" />
                <h3 className="text-lg font-semibold text-gray-600 mb-2">
                    No tienes recetas favoritas
                </h3>
                <p className="text-gray-500 mb-4">
                    Agrega recetas a tus favoritos para verlas aquí
                </p>
            </div>
        );
    }

    return (
        <div>
            <div className="flex items-center justify-between mb-6">
                <div>
                    <h2 className="text-2xl font-bold">Tus Recetas Favoritas</h2>
                    <p className="text-gray-600">
                        {favorites.length} {favorites.length === 1 ? 'receta favorita' : 'recetas favoritas'}
                    </p>
                </div>
                <Button onClick={refetch} variant="outline" size="sm">
                    <RefreshCw className="h-4 w-4 mr-2" />
                    Actualizar
                </Button>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
                {favorites.map((recipe) => (
                    <RecipeCard
                        key={recipe.id}
                        {...recipe}
                        isFavorite={favoriteIds.includes(recipe.id)} // ← Prop
                        toggleFavorite={toggleFavorite} // ← Prop
                        onAddToWeeklyMenu={onAddToWeeklyMenu}
                    />
                ))}
            </div>
        </div>
    );
};

export default FavoriteRecipes;